module.exports = __webpack_public_path__ + "static/img/sad-broke.f823f27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/customer/sad-broke.png
// module id = kZuB
// module chunks = 1